export default __webpack_public_path__ + "static/media/DreamJobs1_09.a073dd3a.png";